module.exports = __webpack_public_path__ + "img/dashboardIcon4.4ac71967.png";